export default {
  title: 'Track your order',
  text: 'Thank you for ordering here! Our <0>{{carrier}}</0> partnership allows us to handle deliveries directly on our site, saving us {{savings}} on average in delivery commission fees. Your order will be delivered by <1>{{carrier}}</1>, ensuring great service 😊',
  labels: {
    delivered_by: 'Delivered by',
  },
  buttons: {
    track_order: 'Get live order updates →',
    track_order_once_confirmed: 'Get live order updates once confirmed',
  },
};
